import React from "react";
import "../styles/log2.css";
import { Link } from "react-router-dom"; 
import backgroundImage from "../assets/login/firstlog.png";

const Log2 = () => {
  return (
    <div className="log2-container">
      <div
        className="log2-background"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      ></div>

      <div className="log2-box">
        <div className="log2-header">
          <h1 className="log2-title">Welcome to Lingayath Weds</h1>
          <p className="log2-subtitle">
            Login with your Lingayat Weds account to manage your profile, view
            matches, and access membership details in one place.
          </p>
        </div>

        <div className="log2-divider"></div>

        <div className="log2-message-section">
          <div className="warning-icon">
            <svg
              width="40"
              height="40"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 9V11M12 15H12.01M5.07183 19H18.9282C20.4678 19 21.4301 17.3333 20.6603 16L13.7321 4C12.9623 2.66667 11.0377 2.66667 10.2679 4L3.33975 16C2.56995 17.3333 3.53223 19 5.07183 19Z"
                stroke="#D97706"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          <p className="log2-message">
            You are already registered.
            <br />
            Redirecting to Home.
          </p>
        </div>

        <div className="log2-divider"></div>

        
        <Link to="/" className="pending-login-btn" style={{ textDecoration: "none", color: "white" }}> 
          Go to Home
        </Link>
      </div>
    </div>
  );
};

export default Log2;
